<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../common/style/variables";
  .layout {
    height: 100%;
    padding-left: calc(100vw - 100%);
    &-content {
      // height: 100%;
      position: relative;
      padding-top: 120px * @scaleRate;
    }
  }
</style>

<template>
  <div class="layout">
    <wt-header></wt-header>
    <main class="layout-content">
      <router-view></router-view>
    </main>
    <footer></footer>
  </div>
</template>

<script>
  import wtHeader from '@/components/wt-header'

  export default {
    components: {
      wtHeader
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Main.vue